<template>
  <b-card no-body v-if="workshop">
    <b-card-header header-tag="header" class="p-1" role="tab">
        Register today! Wellbeing Workshop on {{ workshop.startTime | format('MMMM Do h:mm A') }}: {{ workshop.topic }}
        <router-link :to="workshop_link">Register here!</router-link>
    </b-card-header>
  </b-card>
</template>
<script>
import WorkshopClient from '@/api/WorkshopClient';
import moment from 'moment'

export default {
    name:'WorkshopBanner',
    data() {
        return {
            client: new WorkshopClient(this.$http),
            workshop: null
        }
    },
    computed: {
        workshop_link() {
            return `/workshops/${this.workshop.id}`
        }
    },
    async mounted() {
        try {
            const filters = {
                pageToken: undefined,
                userId: this.$store.getters.currentUser.id,
                startsAfter: undefined,
                startsBefore: undefined,
                specialties: undefined,
                userIsAttending: false,
            }
            const response = await this.client.listForUser(
                filters.pageToken,
                filters.userId,
                filters.startsAfter,
                filters.startsBefore,
                filters.specialties,
                filters.userIsAttending);
            this.successGettingWorkshops(response);
        } catch (ex) {
            this.errorGettingWorkshops(ex);
        }
    },
    methods:{
        successGettingWorkshops(response) {
            if (response && response.workshops && response.workshops.length) {
                this.workshop = response.workshops
                    .filter(x => !x.attending)
                    .map(workshop => ({
                        ...workshop,
                        startTime: moment(workshop.startTime)
                    }))
                    .sort((x, y) => x.startTime - y.startTime)[0];
            } 
        },
        errorGettingWorkshops(error) {
            console.error(error);
            this.emitVisibility(false);
        },
        emitVisibility(visible) {
            this.$emit('visibility', !!visible);
        }
    }
}
</script>
<style lang="scss" scoped>
div.card {
  @include border-radius($border-radius);
  @include pop-blue-gradient;

  padding-left: 5px;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}
</style>